/* assets/mezuzah-cym.js
   MEZUZAH-OWNED FILE (managed by Claude). July 12 session 9;
   v3 session 10; v5 session 12; v6 session 13; v7 session 13;
   v8 session 28 (July 17): THE FIT PILL IS BACK. The v7
   removal was a diagnostic state while two pills showed; the
   second pill was the legacy CSS chip, killed for good by
   r20 block 19 in session 27, so the JS pill is now the ONLY
   pill mechanism. ensurePill() injects span.mez-fitpill as
   the last child of the first CYM feature heading (block 14
   makes that heading a flex row; margin-left auto pushes the
   pill to the opposite side), dedupes document-wide, and a
   body observer re-asserts it after app re-renders.
   Historical v7 note kept below for the record:
   the fit pill was removed entirely (Shay ruling, July 13). Claude's v6 injected a real DOM pill and deduped
   it document-wide; Shay STILL saw two pills in his EDITOR, so
   every Claude-side pill mechanism is now removed rather than
   layered on. r20 v7 also draws no pill. This is a DIAGNOSTIC
   state: with zero Claude pill code anywhere, whatever renders
   on the page is the Section Store plugin's own output, which
   tells us whether the plugin draws it once or twice.
   Removed here: PILL_TEXT, ensurePill(), firstHeading(), the
   `applying` guard, and the body-level MutationObserver.
   What REMAINS: the spec-05 skin for the Section Store addons
   block (open shadow root), the DISPLAY-ONLY running summary
   line, and the Pair-it band checkmark strip. Reads toggle
   state only; never writes to the cart, the product form, or
   the app's own logic. Loaded defer from
   snippets/mezuzah-halachic-card.liquid.
   Note: written without backslash characters on purpose; the
   theme-file transport mangles them (session 9 finding). */
(function () {
  'use strict';
  var HOST_TAG = 'section-store--product-addons-block';
  var PILL_TEXT = 'Scrolls that fit';

  function ensurePill() {
    var pills = document.querySelectorAll('.mez-fitpill');
    var heads = document.querySelectorAll('.product__page .product__features .product__feature__heading');
    if (!heads.length) {
      pills.forEach(function (p) { p.remove(); });
      return;
    }
    var first = heads[0];
    var keep = null;
    pills.forEach(function (p) {
      if (!keep && p.parentElement === first) { keep = p; return; }
      p.remove();
    });
    if (keep) return;
    var span = document.createElement('span');
    span.className = 'mez-fitpill';
    span.textContent = PILL_TEXT;
    first.appendChild(span);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function basePriceCents() {
    var el = document.querySelector('.product__page .product__price');
    if (!el) return null;
    var text = el.textContent || '';
    var i = text.indexOf('$');
    if (i === -1) return null;
    var num = '';
    for (var j = i + 1; j < text.length; j++) {
      var ch = text.charAt(j);
      if ((ch >= '0' && ch <= '9') || ch === '.' || ch === ',') num += ch;
      else if (num) break;
    }
    num = num.split(',').join('');
    var f = parseFloat(num);
    return isNaN(f) ? null : Math.round(f * 100);
  }

  function stripChecks() {
    var ps = document.querySelectorAll('.product__page .product__features .rte p');
    var check = String.fromCharCode(10003);
    var heavy = String.fromCharCode(10004);
    ps.forEach(function (rteP) {
      if (rteP.firstChild && rteP.firstChild.nodeType === 3) {
        var t = rteP.firstChild.nodeValue || '';
        while (t.length && (t.charAt(0) === check || t.charAt(0) === heavy || t.charAt(0) === ' ')) {
          t = t.slice(1);
        }
        rteP.firstChild.nodeValue = t;
      }
    });
  }

  function decorate() {
    stripChecks();
    ensurePill();
  }

  function skin(root) {
    if (root.querySelector('#mez-cym-skin')) return;
    var s = document.createElement('style');
    s.id = 'mez-cym-skin';
    s.textContent = [
      '.addons-box{margin:0 !important;border:0 !important;border-bottom:1px solid #e7e7e7 !important;border-radius:0 !important;padding:13px 16px !important;background:#ffffff !important;position:relative;}',
      '.addons-box:last-of-type{border-bottom:0 !important;}',
      '.addons-box:has(input.addon-toggle-input:checked){box-shadow:inset 3px 0 0 #24466b;}',
      '.product-title{font-size:14px !important;line-height:1.35 !important;color:#1c1c1c !important;}',
      '.product-subtitle .price{font-size:13px !important;font-weight:700 !important;color:#1c1c1c !important;}',
      '.product-subtitle .original-price{font-size:11.5px !important;color:#9a9a9a !important;}',
      '.product-subtitle .discount{font-size:10px !important;font-weight:700 !important;color:#2f6b38 !important;background:#e9f5e6 !important;border-radius:4px !important;padding:2px 6px !important;}',
      '.product-image{border-radius:4px !important;border:1px solid #e7e7e7 !important;}',
      '.header{padding:0 !important;}',
      '.body{padding:0 !important;}'
    ].join(' ');
    root.prepend(s);
  }

  function summaryEl(host) {
    var next = host.nextElementSibling;
    if (next && next.className === 'mez-cym-summary') return next;
    var el = document.createElement('div');
    el.className = 'mez-cym-summary';
    el.setAttribute('aria-live', 'polite');
    host.insertAdjacentElement('afterend', el);
    return el;
  }

  function update(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var boxes = root.querySelectorAll('.addons-box');
    var count = 0;
    var extra = 0;
    boxes.forEach(function (b) {
      var input = b.querySelector('input.addon-toggle-input');
      if (input && input.checked) {
        count += 1;
        extra += parseInt(b.getAttribute('data-variant-price') || '0', 10);
      }
    });
    var el = summaryEl(host);
    var base = basePriceCents();
    var show = base !== null;
    host.classList.toggle('mez-cym-has-summary', show);
    if (!show) { el.style.display = 'none'; return; }
    el.style.display = '';
    var label;
    if (count === 0) label = 'Case only';
    else if (count === 1) label = 'Case + 1 scroll';
    else label = 'Case + ' + count + ' scrolls';
    el.innerHTML = '<span>Your mezuzah: ' + label + '</span><b>' + money(base + extra) + '</b>';
  }

  function wire(host) {
    var root = host.shadowRoot;
    if (!root || host.__mezCym) return;
    host.__mezCym = true;
    skin(root);
    root.addEventListener('change', function () { update(host); });
    new MutationObserver(function () { skin(root); update(host); }).observe(root, { childList: true, subtree: true });
    update(host);
  }

  function init() {
    decorate();
    setTimeout(decorate, 1200);
    setTimeout(decorate, 3500);
    var pillTick = false;
    new MutationObserver(function () {
      if (pillTick) return;
      pillTick = true;
      requestAnimationFrame(function () { pillTick = false; ensurePill(); });
    }).observe(document.body, { childList: true, subtree: true });
    var hosts = document.querySelectorAll(HOST_TAG);
    hosts.forEach(function (host) {
      if (host.shadowRoot) { wire(host); return; }
      var tries = 0;
      var t = setInterval(function () {
        tries += 1;
        if (host.shadowRoot) { clearInterval(t); wire(host); }
        else if (tries > 50) { clearInterval(t); }
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
